import { Dispatch, SetStateAction, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuthModal, useAuthUser } from 'authOld/hooks';
import { HeaderModalOptions } from 'coreOld/constants';
import { supportRequestListPath } from 'support/routes/routePaths';

import RequestHomeView from './RequestHomeView';

const RequestHome = () => {
  const navigate = useNavigate();

  const { user } = useAuthUser();
  const { openAuthModal } = useAuthModal();

  useEffect(() => {
    if (user) {
      navigate(supportRequestListPath());
    }
  }, [user]);

  return (
    <RequestHomeView
      openAuthModal={openAuthModal as Dispatch<SetStateAction<HeaderModalOptions>>}
    />
  );
};

export default RequestHome;
